import { StateCreator } from 'zustand';
// In inProgressIds.slice.ts - make sure this function exists
export interface InProgressIdsSlice {
    inProgressIds: number[];
    setInProgressIds: (ids: number[]) => void;
    addInProgressIds: (ids: number[]) => void; // This function should exist
    removeInProgressIds: (ids: number[]) => void;
    clearInProgressIds: () => void;
}

export const createInProgressIdsSlice: StateCreator<InProgressIdsSlice, [], [], InProgressIdsSlice> = (set) => ({
    inProgressIds: [],

    // Replace all IDs
    setInProgressIds: (ids: number[]) =>
        set(() => ({
            inProgressIds: [...new Set(ids)]
        })),

    // Add new IDs to existing ones without replacing
    addInProgressIds: (ids: number[]) =>
        set((state) => ({
            inProgressIds: [...new Set([...state.inProgressIds, ...ids])]
        })),

    // Remove specific IDs
    removeInProgressIds: (ids: number[]) =>
        set((state) => ({
            inProgressIds: state.inProgressIds.filter((id) => !ids.includes(id))
        })),

    // Clear all IDs
    clearInProgressIds: () =>
        set(() => ({
            inProgressIds: []
        }))
});
